/* StudioSoie · Retours & Solutions — assistant en 4 étapes (section studiosoie-returns). Textes : JSON inline de la section. */
(function () {
  var root = document.querySelector('[data-sst-ret]');
  if (!root) return;
  var i18nEl = root.querySelector('[data-sst-ret-i18n]') || document.querySelector('[data-sst-ret-i18n]');
  if (!i18nEl) { return; }
  var i18n = JSON.parse(i18nEl.textContent);
  var stage = root.querySelector('#sst-ret-stage');
  var dots = root.querySelectorAll('.sst-ret__dot');
  var endpoint = root.getAttribute('data-endpoint');
  var state = { step: 1, order: '', email: '', items: '', reason: '', comment: '', ack: false, declined: [], photos: {}, round2: false };

  function pctLine(tpl, pct) { return (tpl || '').replace('[PCT]', pct); }
  function setDots(n) { dots.forEach(function (d, i) { d.classList.toggle('is-on', i < n); }); }
  function esc(x) { var d = document.createElement('div'); d.textContent = x || ''; return d.innerHTML; }
  function points(txt) { return '<ul class="sst-ret__pts">' + (txt || '').split('\n').filter(Boolean).map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('') + '</ul>'; }

  function render(html) { stage.innerHTML = html; stage.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }

  function step1() {
    setDots(1);
    render(
      '<div class="sst-ret__notice">' + esc(i18n.intimates_warning) + '</div>' +
      '<h2 class="sst-ret__h2">' + esc(i18n.step1_title) + '</h2>' +
      '<label class="sst-ret__lab">' + esc(i18n.order_label) + '</label>' +
      '<input class="sst-ret__inp" id="f-order" placeholder="' + esc(i18n.order_ph) + '" value="' + esc(state.order) + '">' +
      '<label class="sst-ret__lab">' + esc(i18n.email_label) + '</label>' +
      '<input class="sst-ret__inp" id="f-email" type="email" placeholder="' + esc(i18n.email_ph) + '" value="' + esc(state.email) + '">' +
      '<p class="sst-ret__err" id="f-err"></p>' +
      '<button class="sst-ret__btn" id="f-next">' + esc(i18n.continue_btn) + '</button>'
    );
    stage.querySelector('#f-next').onclick = function () {
      var o = stage.querySelector('#f-order').value.trim();
      var e = stage.querySelector('#f-email').value.trim();
      if (!o || !e || e.indexOf('@') < 1) { stage.querySelector('#f-err').textContent = i18n.error_required; return; }
      var prev = null; try { prev = localStorage.getItem('sst_ret_' + o.toUpperCase()); } catch (err) {}
      if (prev) { state.order = o; state.email = e; confirmScreen(prev); return; }
      state.order = o; state.email = e; step2();
    };
  }

  function step2() {
    setDots(2);
    var opts = Object.keys(i18n.reasons).map(function (k) {
      return '<label class="sst-ret__radio"><input type="radio" name="reason" value="' + k + '"' + (state.reason === k ? ' checked' : '') + '><span>' + esc(i18n.reasons[k]) + '</span></label>';
    }).join('');
    render(
      '<h2 class="sst-ret__h2">' + esc(i18n.step2_title) + '</h2>' +
      '<label class="sst-ret__lab">' + esc(i18n.items_label) + '</label>' +
      '<input class="sst-ret__inp" id="f-items" placeholder="' + esc(i18n.items_ph) + '" value="' + esc(state.items) + '">' +
      '<label class="sst-ret__lab">' + esc(i18n.reason_label) + '</label>' +
      '<div class="sst-ret__radios">' + opts + '</div>' +
      '<label class="sst-ret__lab">' + esc(i18n.comment_label) + '</label>' +
      '<textarea class="sst-ret__inp" id="f-comment" rows="2" placeholder="' + esc(i18n.comment_ph) + '">' + esc(state.comment) + '</textarea>' +
      '<label class="sst-ret__ack"><input type="checkbox" id="f-ack"' + (state.ack ? ' checked' : '') + '><span>' + esc(i18n.intimates_ack_label) + '</span></label>' +
      '<p class="sst-ret__err" id="f-err"></p>' +
      '<div class="sst-ret__row"><button class="sst-ret__btn sst-ret__btn--ghost" id="f-back">' + esc(i18n.back_btn) + '</button>' +
      '<button class="sst-ret__btn" id="f-next">' + esc(i18n.continue_btn) + '</button></div>'
    );
    stage.querySelector('#f-back').onclick = step1;
    stage.querySelector('#f-next').onclick = function () {
      var r = stage.querySelector('input[name=reason]:checked');
      var it = stage.querySelector('#f-items').value.trim();
      var ok = stage.querySelector('#f-ack').checked;
      if (!r || !it || !ok) { stage.querySelector('#f-err').textContent = i18n.error_required; return; }
      state.reason = r.value; state.items = it; state.comment = stage.querySelector('#f-comment').value.trim(); state.ack = true;
      if (state.reason === 'damaged' || state.reason === 'not_as_described') { stepDamaged(); } else { stepOffer(1); }
    };
  }

  function offerCards(creditPct, cashPct, onCredit, onCash) {
    return '<div class="sst-ret__offers">' +
      '<div class="sst-ret__offer sst-ret__offer--gold"><span class="sst-ret__badge">' + esc(i18n.credit_badge) + '</span>' +
      '<h3>' + esc(i18n.credit_title) + '</h3><p class="sst-ret__pct">' + esc(pctLine(i18n.credit_pct_line, creditPct)) + '</p>' +
      points(i18n.credit_points) + '<button class="sst-ret__btn" id="' + onCredit + '">' + esc(i18n.choose_btn) + '</button></div>' +
      '<div class="sst-ret__offer"><h3>' + esc(i18n.cash_title) + '</h3><p class="sst-ret__pct sst-ret__pct--soft">' + esc(pctLine(i18n.cash_pct_line, cashPct)) + '</p>' +
      points(i18n.cash_points) + '<button class="sst-ret__btn sst-ret__btn--ghost" id="' + onCash + '">' + esc(i18n.choose_btn) + '</button></div></div>';
  }

  function stepOffer(round) {
    setDots(3);
    var credit = round === 1 ? i18n.pct.credit1 : i18n.pct.credit2;
    var cash = round === 1 ? i18n.pct.cash1 : i18n.pct.cash2;
    render(
      '<h2 class="sst-ret__h2">' + esc(round === 1 ? i18n.offer_title : i18n.offer2_title) + '</h2>' +
      '<p class="sst-ret__soft">' + esc(round === 1 ? i18n.offer_sub : i18n.offer2_sub) + '</p>' +
      offerCards(credit, cash, 'f-credit', 'f-cash') +
      '<p class="sst-ret__linkline"><a href="#" id="f-keep">' + esc(i18n.keep_return_link) + '</a></p>'
    );
    stage.querySelector('#f-credit').onclick = function () { submit('credit_' + credit, credit, 'credit'); };
    stage.querySelector('#f-cash').onclick = function () { submit('cash_' + cash, cash, 'cash'); };
    stage.querySelector('#f-keep').onclick = function (e) {
      e.preventDefault();
      state.declined.push(round === 1 ? 'avoir ' + credit + '% / cash ' + cash + '%' : 'avoir2 ' + credit + '% / cash2 ' + cash + '%');
      if (round === 1) { state.round2 = true; stepOffer(2); } else { stepReturn(false); }
    };
  }

  function stepDamaged() {
    setDots(3);
    render(
      '<h2 class="sst-ret__h2">' + esc(i18n.damaged_title) + '</h2>' +
      '<p class="sst-ret__soft">' + esc(i18n.damaged_sub) + '</p>' +
      '<div class="sst-ret__offers">' +
      '<div class="sst-ret__offer sst-ret__offer--gold"><span class="sst-ret__badge">' + esc(i18n.credit_badge) + '</span><h3>' + esc(i18n.replace_title) + '</h3>' + points(i18n.replace_points) +
      '<button class="sst-ret__btn" id="f-repl">' + esc(i18n.choose_btn) + '</button></div>' +
      '<div class="sst-ret__offer"><h3>' + esc(i18n.credit_title) + '</h3><p class="sst-ret__pct">' + esc(pctLine(i18n.damaged_credit_line, i18n.pct.creditDmg)) + '</p>' + points(i18n.credit_points) +
      '<button class="sst-ret__btn sst-ret__btn--ghost" id="f-crd">' + esc(i18n.choose_btn) + '</button></div>' +
      '<div class="sst-ret__offer"><h3>' + esc(i18n.cash_title) + '</h3><p class="sst-ret__pct sst-ret__pct--soft">' + esc(pctLine(i18n.cash_pct_line, i18n.pct.cashDmg)) + '</p>' + points(i18n.cash_points) +
      '<button class="sst-ret__btn sst-ret__btn--ghost" id="f-csh">' + esc(i18n.choose_btn) + '</button></div>' +
      '</div>' +
      '<p class="sst-ret__linkline"><a href="#" id="f-label">' + esc(i18n.label_option) + '</a></p>'
    );
    stage.querySelector('#f-repl').onclick = function () { submitWithPhotos('replacement', 100, false); };
    stage.querySelector('#f-crd').onclick = function () { submitWithPhotos('credit_' + i18n.pct.creditDmg, i18n.pct.creditDmg, false); };
    stage.querySelector('#f-csh').onclick = function () { submitWithPhotos('cash_' + i18n.pct.cashDmg, i18n.pct.cashDmg, false); };
    stage.querySelector('#f-label').onclick = function (e) { e.preventDefault(); stepReturn(true); };
  }

  var pendingType = null, pendingPct = 0, pendingLabel = false;
  function submitWithPhotos(type, pct, freeLabel) { pendingType = type; pendingPct = pct; pendingLabel = freeLabel; stepPhotos(false); }

  function photoInput(id, label) {
    return '<div class="sst-ret__photo"><label class="sst-ret__lab">' + esc(label) + ' *</label>' +
      '<input type="file" accept="image/*" id="' + id + '" class="sst-ret__file"><img class="sst-ret__thumb" id="' + id + '-th" alt="" style="display:none"></div>';
  }

  function stepReturn(freeLabel) {
    pendingType = 'return_shipment'; pendingPct = 0; pendingLabel = freeLabel;
    stepPhotos(true);
  }

  function stepPhotos(isReturn) {
    setDots(4);
    render(
      '<h2 class="sst-ret__h2">' + esc(isReturn ? i18n.return_title : i18n.damaged_title) + '</h2>' +
      (isReturn ? '<div class="sst-ret__notice">' + esc(i18n.return_warning) + '</div>' : '') +
      '<p class="sst-ret__soft">' + esc(i18n.photos_intro) + '</p>' +
      photoInput('ph1', i18n.photo1_label) + photoInput('ph2', i18n.photo2_label) + photoInput('ph3', i18n.photo3_label) +
      '<p class="sst-ret__err" id="f-err"></p>' +
      '<div class="sst-ret__row"><button class="sst-ret__btn sst-ret__btn--ghost" id="f-back">' + esc(i18n.back_btn) + '</button>' +
      '<button class="sst-ret__btn" id="f-send">' + esc(i18n.submit_return_btn) + '</button></div>'
    );
    ['ph1', 'ph2', 'ph3'].forEach(function (id, idx) {
      stage.querySelector('#' + id).addEventListener('change', function (ev) {
        var f = ev.target.files[0]; if (!f) return;
        shrink(f, function (b64) {
          state.photos[['photo_product', 'photo_packaging', 'photo_label'][idx]] = b64;
          var th = stage.querySelector('#' + id + '-th'); th.src = 'data:image/jpeg;base64,' + b64; th.style.display = 'block';
        });
      });
    });
    stage.querySelector('#f-back').onclick = function () { state.photos = {}; if (state.reason === 'damaged' || state.reason === 'not_as_described') { stepDamaged(); } else { stepOffer(state.round2 ? 2 : 1); } };
    stage.querySelector('#f-send').onclick = function () {
      if (!state.photos.photo_product || !state.photos.photo_packaging || !state.photos.photo_label) { stage.querySelector('#f-err').textContent = i18n.photos_missing; return; }
      submit(pendingType, pendingPct, pendingType === 'return_shipment' ? 'return' : 'offer', true);
    };
  }

  function shrink(file, cb) {
    var img = new Image();
    img.onload = function () {
      var max = 1200, w = img.width, h = img.height;
      if (w > max || h > max) { var r = Math.min(max / w, max / h); w = Math.round(w * r); h = Math.round(h * r); }
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      c.getContext('2d').drawImage(img, 0, 0, w, h);
      cb(c.toDataURL('image/jpeg', 0.75).split(',')[1]);
    };
    img.src = URL.createObjectURL(file);
  }

  function submit(type, pct, kind, withPhotos) {
    var btns = stage.querySelectorAll('button'); btns.forEach(function (b) { b.disabled = true; b.textContent = i18n.sending; });
    var payload = {
      request_type: type,
      order_number: state.order, customer_email: state.email,
      locale: root.getAttribute('data-locale') || 'fr',
      items: (state.items || '').replace(/["\\]/g, '’').slice(0, 300),
      reason: i18n.reasons[state.reason] || state.reason,
      offer_pct: pct, comment: (state.comment || '').replace(/["\\]/g, '’').slice(0, 600),
      intimates_ack: state.ack ? 'oui' : 'non',
      offers_declined: state.declined.join(' | ') || '-',
      free_label_requested: pendingLabel ? 'oui' : 'non',
      submitted_at: new Date().toISOString()
    };
    if (withPhotos) { payload.photo_product = state.photos.photo_product; payload.photo_packaging = state.photos.photo_packaging; payload.photo_label = state.photos.photo_label; }
    fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { if (!r.ok) throw 0; try { localStorage.setItem('sst_ret_' + state.order.toUpperCase(), kind); } catch (err) {} confirmScreen(kind); })
      .catch(function () { var e = stage.querySelector('#f-err'); if (e) e.textContent = i18n.error_generic; btns.forEach(function (b) { b.disabled = false; }); });
  }

  function confirmScreen(kind) {
    setDots(4);
    var t = kind === 'credit' ? i18n.confirm_credit_title : kind === 'cash' ? i18n.confirm_cash_title : i18n.confirm_return_title;
    var x = kind === 'credit' ? i18n.confirm_credit_text : kind === 'cash' ? i18n.confirm_cash_text : i18n.confirm_return_text;
    render('<div class="sst-ret__done"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><circle cx="12" cy="12" r="10"/><path d="m7.5 12.5 3 3 6-7"/></svg><h2 class="sst-ret__h2">' + esc(t) + '</h2><p class="sst-ret__soft">' + esc(x) + '</p></div>');
  }

  step1();
})();
